import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';

import { ModeloVistoriaApiService } from '../editar-modelo-vistoria/services/modelo-vistoria-api.service';
import { ModeloVistoria } from '../editar-modelo-vistoria/models/modelo-vistoria';

export interface TemplateModeloVistoriaDados {
  template: { html: string; gerado: boolean };
  modelo: ModeloVistoria;
}

@Injectable()
export class TemplateModeloVistoriaResolver implements Resolve<TemplateModeloVistoriaDados> {

  constructor(
    private modeloVistoriaApiService: ModeloVistoriaApiService,
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<TemplateModeloVistoriaDados> {
    const id = Number(route.params['id']);

    return forkJoin({
      template: this.modeloVistoriaApiService.getTemplateHtml(id),
      modelo: this.modeloVistoriaApiService.getById(id),
    });
  }
}
